import React from "react";
import BookingForm from "../components/BookingForm";
import IconHovers from "../components/IconHovers";


const Home = () => {
  return (
    <div className="Contact-div">
      <BookingForm />
      <IconHovers />
    </div>
  );
};

export default Home;
